const { keyMirror } = window.Edocat.Utils;

export default keyMirror(['TOGGLE_MODAL', 'INIT_FORM']);
